<template>
  <div class="section section_white">
    <div class="max-width">
      <div class="features">
        <div class="section__head">
          <h2 class="section__title">Features for Modern <br>eCommerce Needs</h2>
          <div class="section__text">A complete set of features built to deliver a shopping experience that drives more sales at every step.</div>
        </div>

        <div class="features__list">
          <div class="features__item fadeIn">
            <div class="features__column">
              <div class="features__label">This Theme is Great for</div>
            </div>
            <div class="features__column">
              <strong>Any Store Volume</strong>
              Built to handle stores that process both small and large numbers of transactions without missing a beat.
            </div>
            <div class="features__column">
              <strong>Content-driven stores</strong>
              Built for merchants who use blogs, press coverage, and promos to drive traffic and build trust before checkout.
            </div>
            <div class="features__column">
              <strong>Visual-first catalogs</strong>
              Built to put imagery at the center — letting your products speak before a single word is read.
            </div>
          </div>

          <div class="features__item fadeIn">
            <div class="features__column">
              <div class="features__label">Cart and Checkout</div>
            </div>
            <div class="features__column">
              <ul>
                <li>Cart notes</li>
                <li>Sticky cart</li>
              </ul>
            </div>
            <div class="features__column">
              <ul>
                <li>Stock counter</li>
                <li>Slide-out cart</li>
              </ul>
            </div>
            <div class="features__column">
              <ul>
                <li>Quick buy</li>
                <li>Quick view</li>
              </ul>
            </div>
          </div>

          <div class="features__item fadeIn">
            <div class="features__column">
              <div class="features__label">Marketing and Conversion</div>
            </div>
            <div class="features__column">
              <ul>
                <li>Countdown timer</li>
                <li>Blogs</li>
                <li>Size chart</li>
                <li>Cross-selling</li>
                <li>Customizable contact form</li>
              </ul>
            </div>
            <div class="features__column">
              <ul>
                <li>Promo banners</li>
                <li>Promo popups</li>
                <li>Recommended products</li>
                <li>Product badges</li>
                <li>Press coverage</li>
              </ul>
            </div>
            <div class="features__column">
              <ul>
                <li>EU translations (EN, FR, IT, DE, ES)</li>
                <li>FAQ page</li>
                <li>In-menu promos</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .features {
    .section__head {
      margin:0 0 2.5rem;
      max-width:420px;
    }

    .section__title {
      font-size:2.5rem;

      @include xs {
        font-size:2rem;
      }
    }

    .section__text {
      max-width:100%;
    }

    &__list {
      display:flex;
      flex-direction:column;
      gap:3.5rem;
    }

    &__item {
      border-top:1px solid var(--color-border);
      padding:1.5rem 0 0;
      gap:2rem;
      display:flex;

      @include md {
        flex-wrap:wrap;
        grid-row-gap:1rem;
      }

      @include xs {
        display:grid;
        grid-template-columns:repeat(2,1fr);
      }
    }

    &__column {
      flex:1;
      font-size:.875rem;

      @include md {
        &:first-child {
          flex:none;
          min-width:100%;
        }
      }

      @include xs {
        &:first-child {
          grid-column:1/-1;
        }
      }

      strong {
        display:block;
        font-size:1rem;
        font-weight:600;
        margin:0 0 .25rem;
      }

      ul {
        list-style:disc;
        margin:0 0 0 1.25rem;
        padding:0;
        display:flex;
        flex-direction:column;
        gap:2px;
      }
    }

    &__label {
      font-size:1.125rem;
      font-weight:600;
      letter-spacing: -0.01em;
    }
  }
</style>
<script setup>
</script>
